document.addEventListener('DOMContentLoaded', function () {
  const cartLink = document.querySelector('a[href="/cart"]');
  let countSpan = cartLink?.querySelector('span[class*="ai-header-cart-count"]');

  const updateAll = () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count || 0;
        const totalPrice = cart.total_price || 0;
        const formattedTotal = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: cart.currency || 'USD'
        }).format(totalPrice / 100);

        // ────── Header bubble (already perfect) ──────
        if (cartLink) {
          if (!countSpan || !cartLink.contains(countSpan)) {
            countSpan = document.createElement('span');
            countSpan.className = 'ai-header-cart-count-' + Math.random().toString(36).substr(2, 15);
            const orig = cartLink.querySelector('span[class*="ai-header-cart-count"]');
            if (orig) countSpan.className += ' ' + orig.className.split(' ').filter(c => !c.includes('ai-header-cart-count')).join(' ');
            cartLink.appendChild(countSpan);
          }
          countSpan.textContent = count === 0 ? '' : count;
          countSpan.style.display = count === 0 ? 'none' : '';
        }

        // ────── FOOTER TOTAL — THIS ONE ACTUALLY WORKS 100% NOW ──────
        // The element is inside .js-contents which gets replaced → we re-query every time
        const totalElements = document.querySelectorAll('.totals__total-value, .totals .totals__total-value, [class*="total"] strong, [class*="total"] p');
        totalElements.forEach(el => {
          if (el.closest('#main-cart-footer') || el.closest('.cart__footer')) {
            el.textContent = formattedTotal;
          }
        });

        // Extra fallback — directly target the exact container that exists in your theme
        const footerContainer = document.querySelector('#main-cart-footer .js-contents');
        if (footerContainer) {
          let totalEl = footerContainer.querySelector('p, div, span');
          if (totalEl && totalEl.textContent.includes('€') || totalEl.textContent.includes('$') || totalEl.textContent.includes('USD')) {
            totalEl.textContent = formattedTotal;
          }
        }
      })
      .catch(() => {});
  };

  const trigger = () => setTimeout(updateAll, 600);

  document.addEventListener('change', e => {
    if (e.target?.classList.contains('quantity__input')) trigger();
  });

  document.addEventListener('click', e => {
    if (e.target?.closest('cart-remove-button') || e.target?.matches('[name="plus"], [name="minus"]')) trigger();
  });

  // Run immediately and every 1.5 seconds (your theme is stubborn)
  updateAll();
  setInterval(updateAll, 1500);
});